import React from "react";
import SaitButton from "../atomic/SaitButton";
import { excelExport } from "../utils/ExcelUtils";
import NomeFileExcel from "../template/NomeFileExcel";
import ExcelIcon from "../icons/ExcelIcon";

export default function GridToolbarFilterButton(props) {
	const [openNomeExport, setOpenNomeExport] = React.useState(false);

	return (
		<>
			<NomeFileExcel
				open={openNomeExport}
				close={() => setOpenNomeExport(false)}
				exportFunction={excelExport}
				exportParams={{
					rowCount: props.rowCount,
					columns: props.columns,
					columnsVisibility: props.columnsVisibility,
					fetchDataForExcel: props.fetchDataForExcel,
					rowBackgroundColor: props.rowBackgroundColor,
				}}
			/>
			<SaitButton
				text="Excel"
				loading={props.isFiltering}
				onClick={() => setOpenNomeExport(true)}
				startIcon={<ExcelIcon />}
				variant="text"
				disabled={props.rows.length === 0}
			/>
		</>
	);
}
